import { Accordion } from '@mui/material';
import useIsVisible from '../../../../hooks/useIsVisible';

const CustomAccordion = ({ children, sx = {}, ...props }) => {
  const { isVisible, bindingRefCallback } = useIsVisible({
    threshold: 0.01,
  });

  return (
    <Accordion
      ref={bindingRefCallback}
      {...props}
      sx={{
        ...sx,
        '& .MuiCollapse-root': {
          // use this trick for correct scrolling in a large form 
          // because scrollIntoView does not scroll due to constant change in scroll length due to animation
          transitionDuration: `${
            isVisible ? '0.2s !important' : '0ms !important'
          }`,
        },
      }}
    >
      {children}
    </Accordion>
  );
};

export default CustomAccordion;
